import React, { useContext, useEffect, useState } from 'react';
import Header from '../../../components/Common/Header/Header';
import ContentApp from '../../../components/ContentApp';
import { useSelector } from 'react-redux';
import { WelletContext } from '../../../context/WelletContext';
import { useParams } from 'react-router-dom';
import { formatDateNormal, getLocale, reservationDetailDate } from '../../../helpers/dates';
import { format } from 'date-fns';
import styles from './CheckShow.module.css';
import { Spinner } from '../../../components/Common/Spinner/Spinner';
import { useTranslation } from 'react-i18next';
import CheckerListIcon from '../../../components/icons/CheckerListIcon';
import { useHistory } from 'react-router-dom';
import DoormanNav from '../../../components/Navs/DoormanNav';

const CheckShow = () => {
  const { id } = useParams();
  const app = useSelector((state) => state.app);
  const welletContext = useContext(WelletContext);
  const [infoEventShow, setInfoEventShow] = useState(null);
  const [loading, setLoading] = useState(true);
  const locale = getLocale(app.language);
  const { t } = useTranslation();
  const history = useHistory();

  const infoEvents = async () => {
    try {
      const infoEvent = await welletContext.apis.tickets.get(
        `/shows/getshowDetail/${id}?lang=${locale}`,
      );
      setInfoEventShow(infoEvent);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    infoEvents();
  }, [id]);

  if (loading) {
    return (
      <div className='d-flex justify-content-center align-items-center' style={{ height: '100vh' }}>
        <Spinner />
      </div>
    );
  }

  if (!infoEventShow) {
    return (
      <div className='d-flex justify-content-center align-items-center' style={{ height: '100vh' }}>
        {t('checkShow.errorLoadingEventData')}
      </div>
    );
  }

  const handleIconClick = () => {
    history.push(`/list-qr-checkin/${infoEventShow.data.id}`);
  };

  return (
    <div>
      <Header
        title={infoEventShow.data.eventName}
        hasBackground={true}
        rightIcon={
          <div onClick={handleIconClick} style={{ cursor: 'pointer' }}>
            <CheckerListIcon />
          </div>
        }
        pathName={`/`}
      />

      <ContentApp menu>
        <div className='card p-3'>
          <div className='d-flex align-items-center'>
            <img
              src={infoEventShow.data.bannerImage}
              alt='Banner'
              style={{
                width: '100px',
                height: '100px',
                borderRadius: '10px',
                objectFit: 'cover',
                marginRight: '10px',
              }}
            />
            <div className='ms-3 d-flex flex-column'>
              <span style={{ fontSize: '20px' }} className={styles.textWeight}>
                {infoEventShow.data.eventName}
              </span>
              <span style={{ fontSize: '16px' }} className='text-secondary'>
                {infoEventShow.data.showName}
              </span>
              <div className={`${styles.textWeight} mt-1`}>
                {formatDateNormal(infoEventShow.data.startDate, locale)}
              </div>
              <div className={styles.textWeight}>{`${format(
                new Date(infoEventShow.data.startDate),
                'h:mm aaa',
              )}`}</div>
            </div>
          </div>
        </div>

        <div className='card p-3 mt-2'>
          <div className={`font-small`}>Tickets</div>
          <div className={`${styles.descriptionTicket} mt-1 bold`}>
            {infoEventShow.data.shortDescription}
          </div>

          <div className='font-small mt-4'>{t('checkShow.startDateTime')}</div>
          <div className='bold mt-1'>
            {reservationDetailDate(infoEventShow.data.startDate, locale)}
          </div>

          <div className='font-small mt-4'>{t('checkShow.endDateTime')}</div>
          <div className='bold mt-1'>
            {reservationDetailDate(infoEventShow.data.endDate, locale)}
          </div>

          <div className='font-small mt-4'>{t('checkShow.amount')}</div>
          <div className='bold mt-1'>
            {infoEventShow.data.ticketsChecked} {t('checkShow.of')}{' '}
            {infoEventShow.data.totalTicketsShow}
          </div>
        </div>
      </ContentApp>

      <DoormanNav history={history} isDisabled={false} id={id} />
    </div>
  );
};

export default CheckShow;
